import ErrorResponse from '../../../components/ErrorResponse';
import Loader from '../../../components/Spinner';
import useAxios from '../../../hooks/useAxios';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  completeRetireTodo,
  getRetiredStudentTodo,
  saveRetiredStudentTodo,
} from '../../../api/refunds.api';
import { Descriptions } from 'antd';
import {
  IGetRetiredStudentTodo,
} from '../../../models/refunds.model';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Button from '../../../components/Button';
import { getCommonCodeLabel } from '../../../lib/store';
import moment from 'moment';
import ConfirmModal from '../../../components/modals/ConfirmModal';
import { cancelRetireTodo } from '../../../api/campusClasses.api';
import useNotification from '../../../hooks/useNotification';
import CompleteRetireModal from '../../../components/payment/retire/detail/modals/CompleteRetireModal';
import _ from 'lodash';

interface IMatch {
  calculateCode: string;
}

const PaymentRetireDetail = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch<IMatch>();
  const calculateCode = Number(match.params.calculateCode);
  const { infoNotification, successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetRetiredStudentTodo>();
  const { data: cancelRes, isLoading: cancelIsLoading, error: cancelError, execute: cancelExecute } = useAxios();
  const { data: saveRes, isLoading: saveIsLoading, error: saveError, execute: saveExecute } = useAxios();
  const { data: saveRes2, isLoading: saveIsLoading2, error: saveError2, execute: saveExecute2 } = useAxios();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  const [memo, setMemo] = useState('');
  const [amounts, setAmounts] = useState<string[]>([]);
  const [amountData, setAmountData] = useState<any[]>([]);
  const [calculateDetails, setCalculateDetails] = useState<any[]>([]);
  const [confirmCancelVisible, setConfirmCancelVisible] = useState(false);
  const [confirmSubmitVisible, setConfirmSubmitVisible] = useState(false);
  const [completeRetireVisible, setCompleteRetireVisible] = useState(false);

  useEffect(() => {
    if (calculateCode) {
      doGetRetiredStudentTodo();
    }
  }, [calculateCode]);

  useEffect(() => {
    if (res && !isLoading) {
      setMemo(res.data?.memo);
      
      let data: any = _.cloneDeep(res?.data?.calculateDetails);
      let dataLength : number = (data) ? data.length : 0;
      const _amounts: string[] = [];
      const _amountData: any[] = [];  //동적생성 변경
      data = _.sortBy(data, 'calculateDetailCode');
      data?.forEach((item: any, index: number) => {
        const monthIndex = item.monthSeq - 1;
        if (!_amountData[monthIndex]) {
          _amountData[monthIndex] = [];
        }

        item.index = index;
        // calculateDiv: RF 환불, NP 미수
        _amounts.push(item.actualPaymentAmount);
        _amountData[monthIndex].push(item);
      });
      setAmounts(_amounts);
      setAmountData(_amountData);
      setCalculateDetails(data);
    }
  }, [res, isLoading]);

  useEffect(() => {
    if (cancelRes && !cancelIsLoading) {
      successNotification(t('common.message.cancel'));
      history.push(`/payment/retire${location.search}`);
    }
  }, [cancelRes, cancelIsLoading]);

  useEffect(() => {
    if (saveRes && !saveIsLoading) {
      doGetRetiredStudentTodo();
      successNotification(t('common.message.save1'));
    }
  }, [saveRes, saveIsLoading]);

  useEffect(() => {
    if (saveRes2 && !saveIsLoading2) {
      submitExecute(completeRetireTodo(calculateCode));
    }
  }, [saveRes2, saveIsLoading2]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      setCompleteRetireVisible(true);
    }
  }, [submitRes, submitIsLoading]);

  const doGetRetiredStudentTodo = () => execute(getRetiredStudentTodo(calculateCode));

  const getTotalAmount = (code: string) => {
    let total = 0;
    calculateDetails.forEach((item, index) => {
      if (code === item.calculateDiv) {
        total += Number(amounts[index]);
      }
    });

    return total.toLocaleString();
  };

  const onSetAmounts = (index: number, value: string) => {
    const _amounts = [...amounts];
    _amounts[index] = value;
    setAmounts(_amounts);
  };

  const onCancel = () => {
    if (!res?.data?.classRetierCode) return;
    setConfirmCancelVisible(false);
    cancelExecute(cancelRetireTodo(res.data.classRetierCode));
  }

  const onSave = (n: number) => {
    const req: any = { memo, details: [] };

    if (calculateDetails.length) {
      for (let i = 0; i < calculateDetails.length; i++) {
        const item = calculateDetails[i];

        if (item.paymentCompleteAmount < Number(amounts[i])) {
          return infoNotification(t('payment.retire.message1'));
        }

        req.details.push({
          calculateDetailCode: item.calculateDetailCode,
          amount: amounts[i],
        });
      }
    }

    n === 1
      ? saveExecute(saveRetiredStudentTodo(calculateCode, req))
      : saveExecute2(saveRetiredStudentTodo(calculateCode, req));
  };

  const renderAmountData = (arr: any) => {
    if (arr.length === 0) return;

    return (
      <>
        <div className='comm-bx__space mt-5'>
          <h4 className='sub-title'>
            {arr[0].semesterName}{' '}
            {getCommonCodeLabel('SY0009', arr[0].monthNameCode?.trim() || '', 'ko')}
          </h4>
        </div>
        <div className='comm-table__area'>
          <table>
            <colgroup>
              <col width="15%" />
              <col width="15%" />
              <col width="15%" />
              <col width="15%" />
              <col width="15%" />
              <col width="15%" />
            </colgroup>
            <thead>
              <tr>
                <th>{t('payment.retire.column5')}</th>
                <th>{t('payment.retire.column6')}</th>
                <th>{t('payment.retire.column7')}</th>
                <th>{t('payment.retire.column8')}</th>
                <th>{t('payment.retire.column9')}</th>
                <th>{t('payment.retire.column10')}</th>
                <th>{t('payment.retire.column11')}</th>
              </tr>
            </thead>
            <tbody>
              {arr.map((item: any) => (
                <tr>
                  <td>
                    {getCommonCodeLabel('PA0001', item.paymentTargetCode, 'ko')}
                  </td>
                  <td>{item.price?.toLocaleString()}</td>
                  <td>{item.totalDiscountAmount?.toLocaleString()}</td>
                  <td>{item.paymentCompleteAmount?.toLocaleString()}</td>
                  <td>{getCommonCodeLabel('PA0009', item.calculateDiv, 'ko')}</td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      value={amounts[item.index]}
                      onChange={(e) => onSetAmounts(item.index, e.target.value)}
                      disabled={res?.data?.calculateStatus === 'FI' || res?.data?.calculateStatus === 'CA'}
                      style={{
                        color: item.calculateDiv === 'RF'
                          ? 'red'
                          : item.calculateDiv === 'NP'
                            ? 'blue'
                            : 'black'
                      }}
                    />
                  </td>
                  <td>{item.note || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  return (
    <div className="content scrollbar">
      {isLoading || cancelIsLoading || saveIsLoading || saveIsLoading2 || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={cancelError} />
      <ErrorResponse error={saveError} />
      <ErrorResponse error={saveError2} />
      <ErrorResponse error={submitError} />

      <div className="col-frame">
        <SimpleHeader
          iconFile="icon-payment-big.svg"
          parentMenu={t('common.menu.payment')}
          currentMenu={t('payment.retire.title1')}
        />
        <div className='comm-table__area rowType'>
          <Descriptions
            bordered
            size="small"
            column={4}
            labelStyle={{ width: '10%' }}
            contentStyle={{ width: '15%' }}
          >
            <Descriptions.Item label={t('payment.retire.column1')}>
              {res?.data?.memberName}
            </Descriptions.Item>
            <Descriptions.Item label={t('common.menu.class')}>
              {res?.data?.className}
            </Descriptions.Item>
            <Descriptions.Item label={t('payment.retire.column12')}>
              {moment(res?.data?.studySrtDate).format('YYYY.MM.DD')}
            </Descriptions.Item>
            <Descriptions.Item label={t('payment.retire.column13')}>
              {moment(res?.data?.studyEndDate).format('YYYY.MM.DD')}
            </Descriptions.Item>
            <Descriptions.Item label={t('payment.retire.column14')}>
              {getCommonCodeLabel('CL0004', res?.data?.retierRsnType || '', 'ko')}
            </Descriptions.Item>
            <Descriptions.Item label={t('payment.retire.column15')}>
              {res?.data?.totalRefundAmount?.toLocaleString()}
            </Descriptions.Item>
            <Descriptions.Item label={t('payment.retire.column16')} span={2}>
              {res?.data?.totalPaymentAmount?.toLocaleString()}
            </Descriptions.Item>
            <Descriptions.Item label={t('common.column.status')}>
              {getCommonCodeLabel('PA0010', res?.data?.calculateStatus || '', i18n.language)}
            </Descriptions.Item>
            <Descriptions.Item label={t('payment.retire.column17')} span={3}>
              {moment(res?.data?.firstRegDttm).format('YYYY.MM.DD')}
            </Descriptions.Item>
            <Descriptions.Item label={t('payment.retire.column18')} span={4}>
              <input
                type="text"
                className="form-control"
                value={memo}
                onChange={(e) => setMemo(e.target.value)}
                disabled={res?.data?.calculateStatus === 'FI' || res?.data?.calculateStatus === 'CA'}
              />
            </Descriptions.Item>
          </Descriptions>
        </div>

        {amountData.map(item => renderAmountData(item))}
        
        <div className='comm-table__area rowType mt-5'>
          <Descriptions bordered size="small" column={1} labelStyle={{ width: '10%' }}>
            <Descriptions.Item label={t('payment.retire.column19')}>
              <span style={{ color: 'red' }}>
                {getTotalAmount('RF')}
              </span>
            </Descriptions.Item>
            <Descriptions.Item label={t('payment.retire.column20')}>
              <span style={{ color: 'blue' }}>
                {getTotalAmount('NP')}
              </span>
            </Descriptions.Item>
          </Descriptions>
        </div>
        <div className='comm-bx__between'>
          <div className="comm-btn__area">
            <Button
              className="btn-basic gray-line"
              onClick={() => history.push(`/payment/retire${location.search}`)}
              text={t('common.button.list')}
            />
          </div>
          <div className="comm-btn__area right"> 
            <Button
              className="btn-basic gray"
              onClick={() => setConfirmCancelVisible(true)}
              text={t('payment.retire.button1')}
              disabled={res?.data?.calculateStatus === 'FI' || res?.data?.calculateStatus === 'CA'}
            />
            <Button
              className="btn-basic pink"
              onClick={() => onSave(1)}
              text={t('common.button.save')}
              disabled={res?.data?.calculateStatus === 'FI' || res?.data?.calculateStatus === 'CA'}
            />
            <Button
              className="btn-basic pink-line"
              onClick={() => setConfirmSubmitVisible(true)}
              text={t('payment.retire.button2')}
              disabled={res?.data?.calculateStatus === 'FI' || res?.data?.calculateStatus === 'CA'}
            />
          </div>
        </div>
      </div>

      {confirmCancelVisible &&
        <ConfirmModal
          visible={confirmCancelVisible}
          setVisible={setConfirmCancelVisible}
          onConfirm={onCancel}
          titleText={t('payment.retire.title2')}
          messageText={t('payment.retire.text1')}
          confirmText={t('common.option.yes')}
          cancelText={t('common.option.no')}
        />      
      }
      {confirmSubmitVisible &&
        <ConfirmModal
          visible={confirmSubmitVisible}
          setVisible={setConfirmSubmitVisible}
          onConfirm={() => {
            setConfirmSubmitVisible(false);
            onSave(2);
          }}
          titleText={t('payment.retire.title3')}
          messageText={t('payment.retire.text2')}
          confirmText={t('payment.retire.button3')}
          cancelText={t('common.button.cancel')}
        />
      }
      {completeRetireVisible &&
        <CompleteRetireModal
          visible={completeRetireVisible}
          setVisible={setCompleteRetireVisible}
          memberCode={res?.data?.memberCode}
          campusCode={res?.data?.campusCode}
        />      
      }
    </div>
  );
};

export default PaymentRetireDetail;
